import request from '@/utils/request'

let Out_managementApi = {

  /*出库列表*/
  list(data) {
    return request._post('/shop/plus.out_management.Index/index', data);
},
listp(data) {
    return request._post('/shop/plus.out_management.Index/indexp', data);
},
sureprint(data) {
    return request._post('/shop/plus.out_management.Index/sureprint', data);
},
/*添加出库*/
add(data) {
    return request._post('/shop/plus.out_management.Index/add', data);
},
// 添加出库 跳过申请 审核 直接创建订单
adda(data) {
    return request._post('/shop/plus.out_management.Index/adda', data);
},
/*修改出库*/
edit(data) {
    return request._post('/shop/plus.out_management.Index/edit', data);
},
/*出库*/
ck(data) {
    return request._post('/shop/plus.out_management.Index/ck', data);
},
getRecord(data) {
    return request._post('/shop/plus.out_management.Index/getRecord', data);
},
record(data) {
    return request._post('/shop/plus.out_management.Index/record', data);
},
passCanel(data) {
    return request._post('/shop/plus.out_management.Index/passCanel', data);
},
/*删除出库*/
del(data) {
    return request._post('/shop/plus.out_management.Index/del', data);
},
/*出库详情*/
detail(data) {
  return request._post('/shop/plus.out_management.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.out_management.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.out_management.Setting/getSetting', data, errorback);
    },
}
export default Out_managementApi;



// WEBPACK FOOTER //
// ./src/api/out_management.js